
import { Navbar } from '@/components/Navbar';
import { LeaksFeed } from '@/components/LeaksFeed';
import { Footer } from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';
import { Helmet } from 'react-helmet';

const Leaks = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>{t('leaks.pageTitle')} | Cybermonit</title>
      </Helmet>
      <Navbar />
      <main className="flex-grow">
        <LeaksFeed />
      </main>
      <Footer />
    </div>
  );
};

export default Leaks;
